module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-table', {
    attrs: {
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "loadingTable": _vm.loadingTable,
      "disableCheckAll": "",
      "disabledConfigCell": "",
      "disableInputSearch": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f35506f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/consulta/_includes/pcmso.vue
// module id = 1593
// module chunks = 45